import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import { IProduct, IGetCategoriesWithProductCountPayload } from "./productModel";

export const findAllProduct = createAsyncThunk("Product/FindAllProduct", async (payload: { Limit?: number; Skip?: number; [key: string]: any }) => {
  try {
    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Product/FindAllProduct`,
      {
        Limit: payload.Limit || 10,
        Skip: payload.Skip || 0,
        ...payload,
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error Fetching Products:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const findAllActiveProduct = createAsyncThunk("Product/FindAllActiveProduct", async () => {
  try {
    const response = await axiosApiInstance.get(
      `${API_PORTAL_URL}/Product/FindAllActiveProduct`
    );
    return response.data?.Data || [];
  } catch (error: any) {
    console.error("Error Fetching Active Products:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const insertProduct = createAsyncThunk(
  "Product/InsertProduct",
  async (productData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/InsertProduct`,
        productData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateProduct = createAsyncThunk(
  "Product/UpdateProduct",
  async (productData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/UpdateProduct`,
        productData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findByIDProduct = createAsyncThunk(
  "Product/FindByIDProduct",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/FindByIDProduct`,
        { ID }
      );
      return response.data?.Data as IProduct;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const activeInActiveProduct = createAsyncThunk(
  "Product/ActiveInActiveProduct",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/ActiveInActiveProduct`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "Product/DeleteProduct",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/DeleteProduct`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const productImagesUpdate = createAsyncThunk(
  "Product/ProductImagesUpdate",
  async (imagedata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/ProductImagesUpdate`,
        imagedata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteProductImage = createAsyncThunk(
  "Product/DeleteProductImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/DeleteProductImage`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findByURLProduct = createAsyncThunk(
  "Product/FindByURLProduct",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/FindByURLProduct`,
        { URL }
      );
      return response.data?.Data;
    } catch (error: any) {
      // Don't show toast for 404/not found as we handle it in UI
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCategoriesWithProductCount = createAsyncThunk(
  "Product/GetCategoriesWithProductCount",
  async (payload?: IGetCategoriesWithProductCountPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/GetCategoriesWithProductCount`,
        {
          IsOnline: Boolean(payload?.IsOnline),
          IsCostToCost: Boolean(payload?.IsCostToCost),
          IsOthersProduct: Boolean(payload?.IsOthersProduct),
        }
      );
      return response.data?.Data || [];
    } catch (error: any) {
      console.error("Error Fetching Category Counts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
